import { showErrorMsg } from '#imports';
import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { getMyNewUserData } from '~/api/oj/home';
import { RouterService } from '~/services/router.service';
import type { MyHomeDataVo } from '~/types/auto/oj';

@Injectable()
export class UserHoverCardService {
  public data = {} as MyHomeDataVo;
  public loading = false;

  @Inject(forwardRef(() => RouterService))
  public routerService!: RouterService;

  getMyHomeRecord(uid: string) {
    this.loading = true;
    this.data = {};
    getMyNewUserData({ uid })
      .then((res) => {
        this.data = res || {};
      })
      .catch((err) => {
        showErrorMsg(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
